import { DATA_AGGREGATION, PERIODS } from './constants';

export default (period: PERIODS): DATA_AGGREGATION =>
  period === PERIODS.LAST_YEAR ? DATA_AGGREGATION.MONTH : DATA_AGGREGATION.DAY;
